export default __webpack_public_path__ + "static/media/js.38323140.png";